import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "voiceoverPlayer", "musicPlayer",
    "voiceoverVolume", "voiceoverVolumeLabel",
    "musicVolume", "musicVolumeLabel"
  ]

  updateVolumeLabel(event) {
    const slider = event.target
    const percentage = Math.round(slider.value * 100)

    // Find the corresponding label via data attribute
    const labelTarget = slider.dataset.labelTarget
    if (labelTarget && this[`has${capitalize(labelTarget)}Target`]) {
      this[`${labelTarget}Target`].textContent = `${percentage}%`
    }
  }
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
